<template>
  <v-dialog
      v-model="showDialog"
      persistent
      max-width="720px"
  >
    <v-card v-if="!!groupData">
      <v-card-title
          class="dialog-header"
          style="
              background-color: #1B6E5A;
              color: white;
              letter-spacing: 0.03rem;
              height: 40px;
            "
          :style="
              $vuetify.breakpoint.xsOnly ? 'text-align: center !important;' : ''
            "
      >
        {{ `Assign Channels - ${groupData.name}` }}
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
                v-bind="attrs"
                v-on="on"
                icon
                width="24px"
                height="24px"
                @click="$emit('close')"
            >
              <v-icon small>
                fas fa-times
              </v-icon>
            </v-btn>
          </template>
          <span>Close</span>
        </v-tooltip>
      </v-card-title>
      <v-card-text style="padding-inline: 4px">
        <div v-if="(availableChannels.length > 0)" class="channel-entries">
          <subscriber-entry
              v-for="(channelItem, channelIndex) in availableChannels"
              :key="`channel-item-key-${channelIndex}`"
              action-assign
              :checked="groupChannels.includes(channelItem.id)"
              :subscriber="channelItem"
              @toggle="toggleChannelHandler(channelItem.id)"
          />
        </div>
        <div v-else>
          <div class="no-results mt-4 text-center">
            No Channels available
          </div>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import {NotificationService} from "@/services/ApiService";
import SubscriberEntry from "@/components/Settings/Notifications/SubscriberEntry.vue";
import {mapActions, mapGetters} from "vuex";

export default {
  name: 'ChannelAssign',
  components: {SubscriberEntry},
  props: {
    show: {
      type: Boolean,
      default: false
    },
    assigning: {
      type: Boolean,
      default: false
    },
    groupData: {
      type: Object,
      default: null,
    }
  },
  data: () => ({
    loading: true,
    availableChannels: [],
    groupChannels: [],
  }),
  computed: {
    ...mapGetters("notifications", ["getChannels"]),
    showDialog: {
      get() {
        if (this.show === true) {
          this.getGroupChannels();
          this.getAvailableChannels();
        }
        return this.show;
      },
      set() {
        this.$emit('close');
      }
    },
  },
  methods: {
    ...mapActions("notifications", ["prepareData"]),
    /**
     * Get the Channels already assigned to the target Subscription Group
     * @returns {Promise<void>}
     */
    async getGroupChannels() {
      try {
        const subscriptionGroupData = await (await NotificationService.NotificationGroups.getById(this.groupData.id)).data;
        // console.log('subscriptionGroupData', subscriptionGroupData);
        this.groupChannels = !!subscriptionGroupData.channels ? subscriptionGroupData.channels.map(channelItem => channelItem.id) : [];
        // console.log('subscriptionGroupData.channels', subscriptionGroupData.channels);
      } catch (error) {
        console.error(error);
      }
      this.loading = false;
    },
    /**
     * Get all the available channels that can be assigned to the subscription
     * group - based on the owner(tenant)
     * @returns {Promise<void>}
     */
    async getAvailableChannels() {
      try {
        // const channelsList = await (await NotificationService.Channels.get()).data;
        const channelTypeTenantList = await (await NotificationService.Channels.getTenantChannels()).data;
        const channelTypesList = await (await NotificationService.Channels.getTypes()).data;
        // console.log('this.groupData', this.groupData);
        // console.log('channelsList', channelsList);
        // console.log('channelTypeTenantList', channelTypeTenantList);
        // console.log('channelTypesList', channelTypesList);
        // console.log(`Owner ID: ${this.groupData.owner}`);
        const refinedChannelsList = this.getChannels.map(channelItem => {
          const tenant = {id: '', name: ''};
          const channel = {id: '', name: '', label: ''};
          channelTypeTenantList.forEach(channelTypeTenantItem => {
            if (channelTypeTenantItem.id === channelItem.channelTypeTenant) {
              tenant.id = channelTypeTenantItem.tenant_id;
            }
          });
          channelTypesList.forEach(channelTypeItem => {
            if (channelItem.channelMessageType === channelTypeItem.name) {
              channel.id = channelTypeItem.id;
              channel.name = channelTypeItem.name;
              channel.label = channelTypeItem.label;
            }
          });
          // console.log(`Tenant ID: ${tenant.id}`);
          return {...channelItem, tenant, channel, checked: false};
        }).filter(refinedChannelItem => {
          return refinedChannelItem.tenant.id === this.groupData.owner;
        });
        // console.log('refinedChannelsList', refinedChannelsList);
        this.availableChannels = refinedChannelsList;
      } catch (error) {
        console.log(error);
      }
    },
    /**
     * Toggle the channel assignment state.
     * Adds or removes a channel from a subscription group based on its ID
     * @param channelID {String} - The ID of the channel to add/remove
     * @returns {Promise<void>}
     */
    async toggleChannelHandler(channelID) {
      try {
        if (!this.groupChannels.includes(channelID)) {
          await NotificationService.Channels.addChannelToGroup(this.groupData.id, channelID);
          this.$notifier.success(`Channel successfully added to subscription group "${this.groupData.name}"`);
          this.groupChannels.push(channelID);
        } else {
          await NotificationService.Channels.removeChannelFromGroup(this.groupData.id, channelID);
          this.groupChannels = this.groupChannels.filter(channel => channel !== channelID);
          this.$notifier.success(`Channel successfully removed from subscription group "${this.groupData.name}"`);
        }
        await this.prepareData();
      } catch (error) {
        console.error(error);
        this.$notifier.success(`Failed to remove Channel to subscription group "${this.groupData.name}"`);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-header {
  display: flex;
  flex-flow: row;
  justify-content: space-between;
  align-items: center;
  padding: 2px 8px !important;
  width: 100%;
}

.channel-entries {
  padding: 8px 12px;
}
</style>